import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { AppStateModel } from '@libs/shared/models';

@Injectable({ providedIn: 'platform' })
@StoreConfig({ name: 'cep', resettable: true })
export class AppStateStore extends Store<AppStateModel> {
  public constructor() {
    super(AppStateStore.getInitialState());
  }

  private static getInitialState(): AppStateModel {
    return {};
  }
}
